export class RenewalPayment {
    personID:number;
    totalCost:number;
    statusCode:string;
    paymentType:string;
    cardNumber:string;
    cardCode:string
    expirationDate:string
    payerName:string;
    address:string;
    city:string;
    state:string;
    zip:string;
    countryId: string;
    //MDName:string;
    //institutionName:string;
    //institutionAddress: string;
    //institutionCity: string;
    //institutionState: string;
    //institutionZip: string;
    Details = [];
    dataDescriptor = null;
    dataValue = null;
}

export class RenewalDetail {
    ServiceCodeID: number;
    Cost:number;
    RenewalYear:number;
    Quantity: number;
}
